import axios from "axios";
import { KEY } from "./ApiPaths";
export default axios.create({
  responseType: "json",
  headers: {
    "content-type": "application/x-www-form-urlencoded",
    "x-api-key": KEY,
  },
});
